import React, { useId } from 'react'
import PropTypes from 'prop-types'
import { Form } from 'react-bootstrap'
import { Button, Menu } from '@CommonComponents/buttons'
import { capitalizeFirstLetter } from '../utils'

export function Filter({
  filters,
  updateFilterState,
  applyFilterState,
  clearFilters,
}) {
  const fieldId = useId()
  const rules = filters.filter(item => item.category === 'rules')
  const severities = filters.filter(item => item.category === 'severities')
  const text = filters.filter(item => item.type === 'text')
  return (
    <React.Fragment>
      <Menu
        id="filter_dropdown_button"
        mode="panel"
        label="Filter"
        surfaceLabel="Rule filters"
        minWidth={300}
        className="me-btn me-btn-secondary me-btn-sm me-btn-menu-trigger"
      >
        <div>
          <Form
            className="px-4 py-3 mx-4"
            onSubmit={e => {
              e.preventDefault()
              applyFilterState()
            }}
          >
            <Form.Group>
              <Form.Group>
                {text.map(item => {
                  return (
                    <React.Fragment key={item.id}>
                      <Form.Label htmlFor={`${fieldId}-text-${item.id}`}>
                        <h5>{item.description}</h5>
                      </Form.Label>
                      <Form.Control
                        id={`${fieldId}-text-${item.id}`}
                        onSelect={e => e.stopPropagation()}
                        onChange={e =>
                          updateFilterState({
                            type: item.type,
                            payload: {
                              id: e.target.dataset.id,
                              value: e.target.value,
                            },
                          })
                        }
                        data-id={item.id}
                        type="text"
                      />
                    </React.Fragment>
                  )
                })}
              </Form.Group>

              <Form.Label>
                <h5>Severity of Error</h5>
              </Form.Label>
              <Form.Group>
                {severities.map(severity => {
                  return (
                    <Form.Check
                      key={severity.id}
                      id={`${fieldId}-severity-${severity.id}`}
                      onClick={e =>
                        updateFilterState({
                          type: 'checkbox',
                          payload: {
                            id: e.target.value,
                          },
                        })
                      }
                      value={severity.id}
                      label={capitalizeFirstLetter(severity.name)}
                    />
                  )
                })}
              </Form.Group>
              <Form.Label>
                <h5>Rules</h5>
              </Form.Label>
              <Form.Group>
                {rules.map(rule => {
                  return (
                    <Form.Check
                      key={rule.id}
                      id={`${fieldId}-rule-${rule.id}`}
                      onClick={e =>
                        updateFilterState({
                          type: 'checkbox',
                          payload: {
                            id: e.target.value,
                          },
                        })
                      }
                      value={rule.id}
                      label={rule.name}
                    />
                  )
                })}
              </Form.Group>
            </Form.Group>
            <Button className="me-btn me-btn-primary m-2" type="submit">
              Apply Filters
            </Button>
            <Button
              className="me-btn me-btn-secondary m-2"
              onClick={clearFilters}
              type="reset"
            >
              Clear Filters
            </Button>
          </Form>
        </div>
      </Menu>
    </React.Fragment>
  )
}

Filter.propTypes = {
  filters: PropTypes.array.isRequired,
  updateFilterState: PropTypes.func.isRequired,
  applyFilterState: PropTypes.func.isRequired,
  clearFilters: PropTypes.func.isRequired,
}
